import React from "react";
import styles from "./loader.module.css"

const Loader = () => {
    return <div className={`${styles.loader}`}></div>
}

export default Loader;